import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import NumberPDFPagesImagesListScreen from "./NumberPDFPagesImagesListScreen";
import { BASE_URL } from "../Config";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function NumberPDFPagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Add Page Numbers To PDF File" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: {
      link: "/number_pdf_pages",
      title: "Add Page Numbers To PDF Online",
    },
    data2: { link: "/number_pdf_pages", title: "Number PDF Pages" },
    data3: {
      link: "/number_pdf_pages",
      title: "Number Pages in PDF File Free",
    },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Add page numbers to PDF files online easily. Number PDF pages quickly and organize documents with our fast and secure PDF numbering tool."
      ></meta>
      <meta
        name="keywords"
        content="number pdf pages, add page numbers to pdf, pdf page numbering, pdf page number tool, insert page numbers pdf, number pages in pdf, pdf editor online, pdf management tool, add pagination to pdf, online pdf numbering, pdf page editor, number pdf online, pdf numbering tool, page numbers pdf, pdf organizer"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <NumberPDFPagesImagesListScreen
          title={title}
        ></NumberPDFPagesImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Add Page Numbers to PDF website offers a simple, secure, and efficient way to organize PDF documents by adding page numbers without requiring an internet connection. Designed to work fully offline, this powerful tool allows users to number PDF pages directly on their device, ensuring complete privacy and data protection. Whether you are working with study materials, legal documents, reports, or eBooks, adding clear and consistent page numbers improves readability and navigation. With this offline-capable solution, you can easily add page numbers to PDF, customize their position, style, and format, and instantly update your document without uploading files to a server. The website also supports advanced numbering options, making it easy to add page index to PDF files for professional presentation. Users who prefer online functionality can also number pages in PDF online when needed, while enjoying the flexibility of offline processing. Optimized for speed and accuracy, the tool preserves original text quality, layout, and formatting while numbering pages efficiently. Ideal for students, professionals, educators, and businesses, this website provides a reliable way to number PDF pages, organize long documents, and prepare files for printing or sharing. If you are looking for a secure, fast, and user-friendly solution to add page numbers to PDF, number PDF pages, or add page index to PDF with offline support, this platform delivers a seamless experience." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Add Numbers",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Number PDF Pages"
            why_use={[
              {
                title: "Improve Document Navigation",
                description:
                  "This number PDF pages tool adds clear page numbers, making it easier to navigate and reference long PDF documents.",
              },
              {
                title: "Professional and Organized Documents",
                description:
                  "Reports, assignments, and legal files look more professional when you add page numbers to PDF documents.",
              },
              {
                title: "Essential for Printing and Binding",
                description:
                  "Page numbering is crucial for printing and binding. A number pages in PDF online or offline tool ensures correct page order.",
              },
              {
                title: "Create a Page Index for Easy Reference",
                description:
                  "Using a tool to add page index to PDF helps readers quickly find specific sections or chapters.",
              },
              {
                title: "Save Time with Automatic Numbering",
                description:
                  "Our number PDF pages tool automatically adds page numbers, saving time compared to manual editing.",
              },
              {
                title: "Preserve Original Layout and Quality",
                description:
                  "When you add page numbers to PDF, modern tools maintain the original text, images, and formatting.",
              },
              {
                title: "Offline Processing for Better Privacy",
                description:
                  "Our offline add page numbers to PDF tool keeps your documents secure by processing files directly on your device.",
              },
              {
                title: "Helpful for Students and Educators",
                description:
                  "Students and teachers use number PDF pages tools for assignments, notes, and academic documents.",
              },
              {
                title: "Ideal for Business and Legal Documents",
                description:
                  "Business reports and legal PDFs require consistent numbering. This number pages in PDF online tool ensures accuracy.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I add page numbers to a PDF online for free?",
                description:
                  "You can add page numbers to a PDF using a PDF page numbering tool. Select your PDF, choose the numbering position and format if available, apply the changes, and download the numbered document."
              },
              {
                title: "What is a PDF page numbering tool?",
                description:
                  "A PDF page numbering tool adds page numbers to PDF documents to make them easier to read, organize, reference, and print. It is useful for reports, books, assignments, invoices, and business documents."
              },
              {
                title: "Can I number PDF pages offline?",
                description:
                  "Yes, if the PDF numbering tool supports offline processing. A browser-based tool that processes documents locally can add page numbers directly on your device after the website and required resources have loaded."
              },
              {
                title: "Does ShivaPDF number PDF pages locally in my browser?",
                description:
                  "Local PDF processing means your document is modified directly in your browser instead of being uploaded to a remote server. Check that the Number PDF Pages tool on ShivaPDF.com supports local processing before using it for confidential files."
              },
              {
                title: "Can I add page numbers to a PDF without uploading it?",
                description:
                  "Yes, if the tool performs all PDF processing locally in your browser. In that case, your document can remain on your device instead of being sent to a server. Confirm local processing support before working with sensitive documents."
              },
              {
                title: "Is it safe to add page numbers to a PDF online?",
                description:
                  "Choose a trusted PDF numbering tool and review its file-processing practices. For confidential documents, consider a tool that processes files locally without uploading them to a remote server."
              },
              {
                title: "Can I choose where page numbers appear in a PDF?",
                description:
                  "Many PDF numbering tools offer placement options such as the top or bottom of a page and left, center, or right alignment. Available positions depend on the tool's supported customization options."
              },
              {
                title: "Can I add page numbers to the bottom of a PDF?",
                description:
                  "Yes, if bottom placement is supported, you can position page numbers in the footer area of your PDF. Centered or right-aligned numbers are common choices for reports, books, and formal documents."
              },
              {
                title: "Can I add page numbers to the top of a PDF?",
                description:
                  "Some PDF numbering tools let you place numbers in the header area at the top of each page. Check the available position settings to choose the layout that suits your document."
              },
              {
                title: "Can I customize the page number format?",
                description:
                  "Depending on the tool, you may be able to customize page numbering formats, starting numbers, prefixes, or other settings. Check the available options before applying numbers to your PDF."
              },
              {
                title: "Can I start PDF page numbering from a specific number?",
                description:
                  "If the tool supports a custom starting number, you can begin numbering from a value other than one. This is useful when adding a PDF section to a larger report or book."
              },
              {
                title: "Can I skip the first page when numbering a PDF?",
                description:
                  "Some PDF numbering tools allow you to exclude the first page or choose a page range. This is useful when a document has a cover page, title page, or introduction that should not display a page number."
              },
              {
                title: "Can I number only selected pages in a PDF?",
                description:
                  "If page-range selection is supported, you can add page numbers to selected pages rather than the entire document. Check the tool's settings to see whether specific pages can be included or excluded."
              },
              {
                title: "Can I change the font and size of PDF page numbers?",
                description:
                  "Some tools offer customization options for page number font, size, color, and style. The available settings depend on the PDF numbering tool."
              },
              {
                title: "Will adding page numbers change my PDF content?",
                description:
                  "Adding page numbers places numbering text onto the pages while generally preserving the existing content. Review the output to ensure the numbers do not overlap important text, images, or other page elements."
              },
              {
                title: "Can I add page numbers to a scanned PDF?",
                description:
                  "Yes, scanned documents saved as PDFs can generally be numbered like other PDF files. Page numbers can be added without converting the scanned page images into editable text, provided the tool supports the document."
              },
              {
                title: "Can I number a large PDF with hundreds of pages?",
                description:
                  "Large PDFs can often be numbered, but processing time and supported file size depend on the tool, browser, and available device memory. For very large documents, allow enough time for processing to finish."
              },
              {
                title: "Can I add page numbers to a PDF on my mobile phone?",
                description:
                  "You can use a mobile-compatible PDF numbering tool on an Android phone, iPhone, or tablet. Compatibility and performance depend on your browser, device resources, and the tool's supported features."
              },
              {
                title: "Can I number PDF pages on Windows and Mac?",
                description:
                  "Yes, you can use a compatible browser-based PDF numbering tool on Windows or macOS. If local processing is supported, the document can be modified directly in your browser without installing separate software."
              },
              {
                title: "Do I need to install software to number PDF pages?",
                description:
                  "A browser-based PDF page numbering tool can let you add numbers without installing a separate application. Depending on the tool's offline support, an internet connection may still be needed to load the website."
              },
              {
                title: "Will numbering PDF pages reduce document quality?",
                description:
                  "Adding page numbers should generally preserve the original page content and image quality when no additional compression or conversion is performed. Check the downloaded PDF to confirm the result."
              },
              {
                title: "Why are my PDF page numbers not visible?",
                description:
                  "Page numbers may be difficult to see if their color blends into the background, their position is outside the visible page area, or their size is too small. Review the placement and formatting settings and generate the PDF again."
              },
              {
                title: "Why can't I download my numbered PDF?",
                description:
                  "Make sure the numbering process has completed and your browser permits downloads. If the download fails, try again, check available device storage, and use a supported browser."
              },
              {
                title: "Is the Number PDF Pages tool on ShivaPDF free?",
                description:
                  "Visit the Number PDF Pages page on ShivaPDF.com to check current availability, file-size limits, and usage restrictions. Features and limits depend on the tool's current implementation."
              }
            ]} />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default NumberPDFPagesMain;
